/**
 * Metron Marque — the three-circle brand mark.
 *
 * Geometry matches the canonical SVG in the Metron Design System bundle
 * (assets/marque-inboard.svg): viewBox 151x251, big center ring R=33 stroke 16,
 * small rings R=21 stroke 12, connecting arms stroke 14.
 *
 * The marque represents (per brand guide p.5):
 *   1. Connected devices
 *   2. Master-meter / sub-meter solutions
 *   3. A water molecule
 *
 * Brand-guide rules:
 *   - Never rotated arbitrarily.
 *   - Never incorporated into illustrations.
 *   - Color is normally Metron Blue (#0674B7) on light backgrounds and
 *     Metron Blue 2 (#0EA6DF) on dark backgrounds.
 */
import * as React from 'react';

interface MarqueProps extends React.SVGProps<SVGSVGElement> {
  /** Rendered height in pixels. Width is derived from the marque's aspect ratio. */
  size?: number;
  /** Stroke color. Defaults to `currentColor` so the parent text color drives the marque. */
  color?: string;
}

const ASPECT = 151 / 251;

export function Marque({ size = 28, color = 'currentColor', ...rest }: MarqueProps) {
  return (
    <svg
      width={size * ASPECT}
      height={size}
      viewBox='0 0 151 251'
      fill='none'
      stroke={color}
      aria-hidden='true'
      {...rest}
    >
      <line x1='60.99' y1='109.37' x2='111.09' y2='40.94' strokeWidth='14' />
      <line x1='61.23' y1='162.45' x2='93.15' y2='205.26' strokeWidth='14' />
      <circle cx='123.5' cy='24' r='21' strokeWidth='12' />
      <circle cx='106' cy='222.5' r='21.5' strokeWidth='12' />
      <circle cx='41.5' cy='136' r='33' strokeWidth='16' />
    </svg>
  );
}
